import type {CSSProperties} from 'react';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgeAccountDeletedLook = 'account-deleted-ok';

export const isWedgeAccountDeletedLook = (look: string | undefined): look is WedgeAccountDeletedLook => look === 'account-deleted-ok';

/* Released account deleted notice (native iOS delete flow, over the fixed scrim): the single "I understand" block at the foot of the panel. It is a
   full-width, 50px tall, 14px radius block filled with the page ink (the label role) and printed in the page background (the bg role), with no
   border, 16px semibold type in the Wedge font and the touch action at manipulation. It reads the exact legacy roles and keeps the declaration
   order of the source, so the shipped ink rules keep matching the serialized text. The bg ink is the bare variable, as the source writes it.
   It draws no transparent target and no anchor (wedgeSettingsDrawsHit, and a `content: none` rule naming the look): the block is already 50px
   tall and full width, so a 44px region could only repeat the box. The caller keeps the `wedge-pressable` class. */
const HEIGHT = 50, RADIUS = 14;

export function wedgeAccountDeletedStyle(_look: WedgeAccountDeletedLook): CSSProperties {
  const r = wedgeExactRole;
  return {
    width: '100%', height: HEIGHT, borderRadius: RADIUS,
    background: r('label'), color: r('bg'),
    border: 0, cursor: 'pointer',
    fontSize: 16, fontWeight: 600, fontFamily: r('font'),
    touchAction: 'manipulation',
  };
}
